import React from 'react';
import { useHistory } from 'react-router-dom';

import { ReactComponent as BackIcon } from '@/assets/icons/back.svg';

export interface BackButtonProps {
  backUrl: string;
  className?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({ backUrl, className }: BackButtonProps) => {
  const history = useHistory();
  return <BackIcon onClick={(): void => history.push(backUrl)} className={className} />;
};

export const withBackURL = (backUrl: string) => (props: Omit<BackButtonProps, 'backUrl'>): React.ReactElement => (
  <BackButton backUrl={backUrl} {...props} />
);

export default BackButton;
